// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;

// State Selector
// super simplified function to make the state selector work.

/*

    Useage Instructions

    1. Add the class js-scroll-to the selector
    2. Add the data attribute target to the selector
    3. Add the ID of the selector your wanting to scroll to
    4. Add the ID into the selector

*/

const settings = {
    triggerSelector: '.js-scroll-to, [data-scrollTo]',
    speed: 600
};


export default function scrollTo() {

    var cache = {};

    function cacheElements () {
        // caching elements to avoid excessive DOM traversing.
        cache.body = $(document.body);
    }

    function scrollToElement (event) {

        if (event.preventDefault !== undefined) {
            console.log("has preventDefault");
        }

        // target element to scroll to
        var eventTarget = $(this);
        var data = eventTarget.data();
        var target = false;

        if (data && data.target) {
            target = $(data.target);
        } else {
            var href = eventTarget.attr('href');
            if (href && href.length && href.length > 1) {
                target = $(href);
            }
        }


        if (target.length) {
            // scroll to the element
            $('html, body').animate({
                scrollTop : target.first().offset().top
            }, settings.speed);
        }

        // prevents any jumpiness on a#hrefs
        event.preventDefault();

    }


    function bindEvents () {
        // on input change, change visible elements
        cache.body.on('click.scroll-to', settings.triggerSelector, scrollToElement);
    }




    function init() {

        // cache the elements
        cacheElements();

        // run events
        bindEvents();

    }

    // auto executes.
    init();

}

// auto inits.
scrollTo();
